import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

import { toRefs } from 'vue';
import useChildBranchIcons from '@/utilities/composables/useChildBranchIcons';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChildBranchIcons',
  props: {
    depth: { default: 0 },
    depthSiblings: { default: () => [] },
    isChild: { type: Boolean, default: false },
    lastItem: { type: Boolean, default: false },
    rowMinHeight: { default: '40px' }
  },
  setup(__props: any) {

const props = __props;

const { depth = 0, isChild = false, rowMinHeight = '40px' } = toRefs(props);

const { getBranchIconStyle } = useChildBranchIcons();

const branchIconStyle = (i, propsParam = props) => getBranchIconStyle(i, propsParam);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["child-branch-wrapper flex h-full", `min-h-[${_unref(rowMinHeight)}]`])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(depth), (i) => {
      return (_openBlock(), _createElementBlock("em", {
        key: i,
        class: _normalizeClass(["w-0", { 'pl-4 ml-2 flex': _unref(isChild) }]),
        style: _normalizeStyle({
        ...branchIconStyle(i),
      })
      }, null, 6))
    }), 128))
  ], 2))
}
}

})